import { mixinDevice } from '@/utils/mixin.js';
import { getSmsCaptcha } from '@/api/login';
import { getAction, postAction } from '@/api/manage';
import { checkOnlyUser } from '@/api/api';
import { duplicateCheck } from '@/api/user';
import { jumpMixins } from "@/utils/jumpMixins";
var levelNames = {
  0: '低',
  1: '低',
  2: '中',
  3: '强'
};
var levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
};
var levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
};
export default {
  name: "Register",
  components: {},
  mixins: [mixinDevice, jumpMixins],
  data: function data() {
    return {
      form: null,
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
      registerBtn: false
    };
  },
  computed: {
    passwordLevelClass: function passwordLevelClass() {
      return levelClass[this.state.passwordLevel];
    },
    passwordLevelName: function passwordLevelName() {
      return levelNames[this.state.passwordLevel];
    },
    passwordLevelColor: function passwordLevelColor() {
      return levelColor[this.state.passwordLevel];
    }
  },
  methods: {
    checkUsername: function checkUsername(rule, value, callback) {
      var params = {
        username: value
      };
      checkOnlyUser(params).then(function (res) {
        if (res.success) {
          callback();
        } else {
          callback("账号已存在！忘记密码可尝试使用身份证件信息后六位数字登录");
        }
      });
    },
    handlePasswordLevel: function handlePasswordLevel(rule, value, callback) {
      var level = 0;
      var reg = /^[\w]{6,}$/;
      if (!reg.test(value)) {
        callback(new Error('密码为6位数字、字母组合，建议区分大小写'));
      }
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++;
      }
      this.state.passwordLevel = level;
      this.state.percent = level * 30;
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100;
        }
        callback();
      } else {
        if (level === 0) {
          this.state.percent = 10;
        }
        callback(new Error('密码强度不够'));
      }
    },
    handlePasswordCheck: function handlePasswordCheck(rule, value, callback) {
      var password = this.form.getFieldValue('password');
      //console.log('value', value)
      if (value === undefined) {
        callback(new Error('请输入密码'));
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'));
      }
      callback();
    },
    handlePhoneCheck: function handlePhoneCheck(rule, value, callback) {
      var params = {
        phone: value
      };
      checkOnlyUser(params).then(function (res) {
        if (res.success) {
          callback();
        } else {
          callback("手机号已存在!");
        }
      });
    },
    handleEmailCheck: function handleEmailCheck(rule, value, callback) {
      if (!value) {
        callback();
      }
      var params = {
        email: value
      };
      checkOnlyUser(params).then(function (res) {
        if (res.success) {
          callback();
        } else {
          callback("邮箱已存在!");
        }
      });
    },
    handlePasswordInputClick: function handlePasswordInputClick() {
      if (!this.isMobile()) {
        this.state.passwordLevelChecked = true;
        return;
      }
      this.state.passwordLevelChecked = false;
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      this.form.validateFields(function (err, values) {
        console.log(values);
        if (!err) {
          var register = {
            username: values.username,
            realname: values.realname,
            password: values.password,
            email: values.email,
            phone: values.phone,
            smscode: values.captcha,
            address: values.address,
            school: values.school,
            identity: values.identity,
            role: 'student'
          };
          postAction("/sys/user/register", register).then(function (res) {
            if (!res.success) {
              _this.registerFailed(res.message);
            } else {
              _this.$emit('success');
              _this.$notification.success({
                message: "提示",
                description: "\u6CE8\u518C\u6210\u529F"
              });
              //this.$router.push({name: 'login'})
              if (_this.$route.query.backUrl) {
                _this.$router.push({
                  name: 'login',
                  query: {
                    backUrl: _this.$route.query.backUrl
                  }
                });
              } else {
                _this.$router.push({
                  name: 'login'
                });
              }
            }
          });
        }
      });
    },
    // getCaptcha(e) {
    //   e.preventDefault()
    //   let that = this
    //   this.form.validateFields(['mobile'], {force: true}, (err, values) => {
    //       if (!err) {
    //         this.state.smsSendBtn = true;
    //         let interval = window.setInterval(() => {
    //           if (that.state.time-- <= 0) {
    //             that.state.time = 60;
    //             that.state.smsSendBtn = false;
    //             window.clearInterval(interval);
    //           }
    //         }, 1000);
    //         const hide = this.$message.loading('验证码发送中..', 0);
    //         const params = {
    //           mobile: values.mobile,
    //           smsmode: "1"
    //         };
    //         postAction("/sys/sms", params).then((res) => {
    //           if (!res.success) {
    //             this.registerFailed(res.message);
    //             setTimeout(hide, 0);
    //           }
    //           setTimeout(hide, 500);
    //         }).catch(err => {
    //           setTimeout(hide, 1);
    //           clearInterval(interval);
    //           that.state.time = 60;
    //           that.state.smsSendBtn = false;
    //           this.requestFailed(err);
    //         });
    //       }
    //     }
    //   );
    // },
    registerFailed: function registerFailed(message) {
      this.$notification['error']({
        message: "注册失败",
        description: message,
        duration: 2
      });
    },
    requestFailed: function requestFailed(err) {
      this.$notification['error']({
        message: '错误',
        description: ((err.response || {}).data || {}).message || "请求出现错误，请稍后再试",
        duration: 4
      });
      this.registerBtn = false;
    }
  },
  watch: {
    'state.passwordLevel': function statePasswordLevel(val) {
      console.log(val);
    }
  }
};